import React from 'react';
import classNames from 'classnames';
import {LoadMoreControl} from '../../../../../../components/pagination/load-more-control/load-more-control';
import styles from '../right-panel.module.css';

interface Props {
    isShowingMore: boolean;
    onClick: () => void;
    level: 2 | 3;
}

export function ShowMoreButton(props: Props) {
    return (
        <LoadMoreControl
            onClick={props.onClick}
            className={classNames(styles.showMoreBtn, {
                [styles.statItemLevel2]: props.level === 2,
                [styles.statItemLevel3]: props.level === 3
            })}
            key={props.isShowingMore ? 'hideIrrelevant' : 'showAll'}
        >
            {props.isShowingMore ? 'Hide irrelevant' : '...Show irrelevant'}
        </LoadMoreControl>
    );
}
